(function() {
  'use strict';

  // ── 品牌尺码表 ──
  var SIZE_CHART = [
    { size: 'S',   heightMin: 160, heightMax: 168, weightMin: 50,  weightMax: 62,  fit: 'Relaxed fit for petite frame' },
    { size: 'M',   heightMin: 168, heightMax: 175, weightMin: 62,  weightMax: 73,  fit: 'Standard relaxed fit' },
    { size: 'L',   heightMin: 175, heightMax: 182, weightMin: 73,  weightMax: 84,  fit: 'Relaxed drop shoulder fit' },
    { size: 'XL',  heightMin: 182, heightMax: 188, weightMin: 84,  weightMax: 95,  fit: 'Oversized relaxed fit' },
    { size: '2XL', heightMin: 185, heightMax: 192, weightMin: 95,  weightMax: 108, fit: 'Plus size relaxed fit' },
    { size: '3XL', heightMin: 190, heightMax: 198, weightMin: 108, weightMax: 122, fit: 'Oversized plus size fit' }
  ];

  // ── State ──
  var state = {
    heightUnit: 'cm',
    weightUnit: 'kg',
    gender: 'unisex',
    recommendedSize: null,
    recommendedFit: null
  };

  // ── 尺码计算（得分制，兼容重叠区间）──
  function calcSize(heightCm, weightKg) {
    var bestIndex = 0, bestScore = -1;
    SIZE_CHART.forEach(function(entry, i) {
      function score(val, min, max) {
        if (val >= min && val < max) return 100;
        var dist = Math.min(Math.abs(val - min), Math.abs(val - max));
        return Math.max(0, 100 - dist * 5);
      }
      var total = score(heightCm, entry.heightMin, entry.heightMax) * 0.5
                + score(weightKg, entry.weightMin, entry.weightMax) * 0.5;
      if (total > bestScore) { bestScore = total; bestIndex = i; }
    });
    return SIZE_CHART[bestIndex];
  }

  // ── DOM 就绪后初始化 ──
  function init() {
    var overlay  = document.getElementById('fit-quiz-overlay');
    var openBtn  = document.getElementById('fit-quiz-open-btn');
    var closeBtn = document.getElementById('fit-quiz-close');
    var step1    = document.getElementById('fit-quiz-step-1');
    var step2    = document.getElementById('fit-quiz-step-2');
    var errEl    = document.getElementById('fit-quiz-error');

    if (!overlay || !openBtn) return; // 页面上没有 quiz，跳过

    // 打开
    openBtn.addEventListener('click', function() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      step1.style.display = '';
      step2.style.display = 'none';
      errEl.style.display = 'none';
    });

    // 关闭
    function closeQuiz() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    closeBtn.addEventListener('click', closeQuiz);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeQuiz();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeQuiz();
    });

    // 单位切换
    window.fitQuizSetHeightUnit = function(unit) {
      state.heightUnit = unit;
      overlay.querySelectorAll('[data-height-unit]').forEach(function(b) {
        b.classList.toggle('active', b.dataset.heightUnit === unit);
      });
    };
    window.fitQuizSetWeightUnit = function(unit) {
      state.weightUnit = unit;
      overlay.querySelectorAll('[data-weight-unit]').forEach(function(b) {
        b.classList.toggle('active', b.dataset.weightUnit === unit);
      });
    };
    window.fitQuizSetGender = function(gender) {
      state.gender = gender;
      overlay.querySelectorAll('.fit-quiz-gender-btn').forEach(function(b) {
        b.classList.toggle('active', b.dataset.gender === gender);
      });
    };

    // 计算
    window.fitQuizCalculate = function() {
      var hVal = parseFloat(document.getElementById('fq-height').value);
      var wVal = parseFloat(document.getElementById('fq-weight').value);
      var aVal = parseFloat(document.getElementById('fq-age').value);

      if (!hVal || !wVal || !aVal) {
        errEl.style.display = '';
        return;
      }
      errEl.style.display = 'none';

      var heightCm = state.heightUnit === 'ft' ? hVal * 30.48 : hVal;
      var weightKg = state.weightUnit === 'lbs' ? wVal * 0.4536 : wVal;

      var result = calcSize(heightCm, weightKg);
      state.recommendedSize = result.size;
      state.recommendedFit  = result.fit;

      document.getElementById('fit-quiz-result-badge').textContent = result.size;
      document.getElementById('fit-quiz-result-note').textContent  = result.fit;
      step1.style.display = 'none';
      step2.style.display = '';
    };

    // 应用尺码 → 自动选中 radio
    window.fitQuizApplySize = function() {
      var size = state.recommendedSize;
      if (!size) return;
      var matched = false;
      document.querySelectorAll('.product__option-input').forEach(function(input) {
        if (input.value.toUpperCase() === size.toUpperCase()) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          matched = true;
        }
      });
      if (matched) {
        closeQuiz();
        var sizeEl = document.querySelector('.product__option');
        if (sizeEl) sizeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        document.getElementById('fit-quiz-result-note').textContent =
          'Size ' + size + ' is not available for this product.';
      }
    };

    // 返回重填
    window.fitQuizBack = function() {
      step1.style.display = '';
      step2.style.display = 'none';
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
